import { Heart } from "lucide-react";

function getCopyrightYears() {
  const startYear = 2024;
  const currentYear = new Date().getFullYear();
  return currentYear > startYear
    ? `${startYear}–${currentYear}`
    : startYear.toString();
}

export function Footer() {
  return (
    <footer className="mt-10 border-t border-[#efe8e5] bg-white/80 py-8 backdrop-blur-md sm:mt-14">
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-4 px-4 sm:flex-row sm:px-6 lg:px-8">
        <div className="text-xs font-medium tracking-[0.14em] text-[#431908]/70">
          rb2 service desk
        </div>

        <div className="flex items-center space-x-2">
          <span className="text-sm text-[#431908] font-sans">Made with</span>
          <Heart className="h-4 w-4 text-[#fe150a] fill-[#fe150a]" />
          <span className="text-sm text-[#431908] font-sans">by</span>
          <a
            href="https://rb2.nl"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-medium text-[#fe150a] hover:text-[#e31700] font-sans flex items-center"
          >
            rb2
          </a>
        </div>

        <div className="text-xs text-[#431908]/85 font-sans">
          © {getCopyrightYears()} rb2.
        </div>
      </div>
    </footer>
  );
}
